import {Component, inject, OnInit} from '@angular/core';
import {ButtonPadraoComponent} from '../shared/components/button-padrao/button-padrao.component';
import {FormFieldComponent} from '../shared/components/form-field/form-field.component';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow, MatRowDef, MatTable, MatTableDataSource, MatTableModule
} from '@angular/material/table';
import {TituloRotinaComponent} from '../shared/components/app-titulo/titulo-component';
import {CanalModel} from '../shared/model/canal/canal-model';
import {MatDialog} from '@angular/material/dialog';
import {ModalCadastroVisualizacaoCanalComponent} from './modal-cadastro-visualizacao-canal/modal-cadastro-visualizacao-canal.component';
import {CanalService} from '../shared/service/canal.service';
import {MsgService} from '../shared/service/msg.service';
import {DatePipe} from '@angular/common';
import { TabelaSkeletonComponent } from '../shared/components/tabela-skeleton/tabela-skeleton.component';
import { MatIcon } from '@angular/material/icon';
import {ValidacaoAlteracaoCampoService} from '../shared/service/utilitarios/validacao-alteracao-campo.service';
import {TemplateModel} from '../shared/model/template/template-model';
import {environment} from '../../../environments/environment';
import {AuthService} from '../shared/service/auth.service';
import {DomSanitizer} from '@angular/platform-browser';
import {MatTooltip} from '@angular/material/tooltip';

@Component({
  selector: 'app-canais',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    FormFieldComponent,
    MatTableModule,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
    TituloRotinaComponent,
    DatePipe,
    TabelaSkeletonComponent,
    MatIcon,
    MatTooltip,
  ],
  templateUrl: './canais.component.html',
  styleUrl: './canais.component.css'
})
export class CanaisComponent implements OnInit {
  canais: CanalModel[] = [];
  canaisDataSource = new MatTableDataSource<CanalModel>();
  displayedColumns: string[] = ['acao', 'nome', 'descricao', 'status', 'privado', 'externo', 'usuCriacao', 'dataCriacao', 'usuAlteracao', 'dataAlteracao', 'qtdOperadores', 'qtdTemplates', 'coordenadores'];
  carregandoCanais = false;
  canaisCarregados = false;

  private readonly dialog = inject(MatDialog);
  private readonly canalService = inject(CanalService);
  private readonly msgService = inject(MsgService);
  private readonly authService = inject(AuthService);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);

  ngOnInit() {
    this.buscarTodosCanais();
  }

  buscarTodosCanais(){
    this.carregandoCanais = true;
    this.canaisCarregados = false;
    this.canalService.buscarTodosCanais().subscribe({
      next: res => {
        this.canaisDataSource.data = res;
        this.canais = res;
      },
      complete: () => {
        this.carregandoCanais = false;
        this.canaisCarregados = true;
      }
    });
  }

  abrirModal(visualizar: boolean, canal?: CanalModel) {
    const canalEnvio = new CanalModel(canal?.id, canal?.nome, canal?.descricao, canal?.ativo, canal?.usuarioCriacao,
      canal?.dataCriacao, canal?.usuarioAlteracao, canal?.dataAlteracao, canal?.grupo, canal?.operadores,
      canal?.coordenadores, canal?.templates, canal?.mensagemInatividade, canal?.mensagemInatividadeFuncionamento,
      canal?.inatividadeAtiva, canal?.horariosFuncionamento, canal?.periodosInatividade, canal?.privado, canal?.externo);
    const dialogRef = this.dialog.open(ModalCadastroVisualizacaoCanalComponent, {
      width: '1120px',
      maxWidth: '100vw',
      height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: { visualizar, canal: JSON.stringify(canalEnvio) },
      panelClass: 'slide-modal',
      disableClose: !visualizar
    });

    if (!visualizar) {
      dialogRef.backdropClick().subscribe(() => {
        const podeFechar = !this.alteracaoService.isCamposAlteracao() ||
          window.confirm('Pode possuir alterações não salvas, deseja fechar?');
        if (podeFechar) { dialogRef.close(); }
      });
    }

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) {
          // enviando apenas o id do template para vinculo
          res.templates = res.templates.map((template: TemplateModel) => ({ id: template.id }));

          this.canalService.criarEditarCanal(res).subscribe({
            next: () => this.msgService.msgSucesso(res.id ? 'Canal editado com sucesso!' : 'Canal criado com sucesso!'),
            error: () => this.msgService.msgErro('Erro ao criar/editar canal!'),
            complete: () => this.buscarTodosCanais()
          });
        }
      }
    });
  }

  filtrarGrupos(filtro: string) {
    this.canaisDataSource.data = this.canais.filter(can => can.nome!.toLowerCase().includes(filtro.toLowerCase()));
  }

  gerarUrl(nomeArquivo: string, extensao: string, path: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(`${environment.urlRepositorioClaribot}/${this.authService.getUsuarioLogado().grupo}/${path}/${nomeArquivo}.${extensao}`);
  }
}
